/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestTestMaxCommandTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_TEST_MAX_COMMAND_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class NewAutoTestTestMaxCommandTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestTestMaxCommandTimeSettingParser.decode(input).map(res => new NewAutoTestTestMaxCommandTimeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestTestMaxCommandTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestTestMaxCommandTimeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestTestMaxCommandTimeSettingParser.schema();
    }
}
